import { createFileRoute } from '@tanstack/react-router';

type Search = {
  type?: 'appointment-type' | 'category' | 'sentiment' | 'service-quality';
  locationId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/call-intelligence/$id')({
  validateSearch: (search: Search): Search => {
    return {
      locationId: search.locationId,
      type: search.type,
    };
  },
});
